export const rentbondURLWithParams = (params: string = '') => {
  return `https://www.rentbond.com.au/?utm_source=ptc&utm_medium=768${params}&utm_campaign=rentbond`
}

export const renbondApplyNowURLWithParams = (params: string = '') => {
  return `https://rentbond.com.au/rentbond/application/personal-info?utm_source=ptc&utm_medium=768${params}&utm_campaign=rentbond`
}

export const RENTBOND_DASHBOARD_PARAM = 'dashboard'
export const RENTBOND_APP_SUBMIT_PARAM = 'appsubmit'
export const RENTBOND_LEARN_MORE_PARAM = 'learnmore'
